import { WeetProvider } from '@wepie/weet';
import { defineApp } from 'dumi';
export default defineApp({
  rootContainer: (dom) => <WeetProvider>{dom}</WeetProvider>,
});
